import http from "@/assets/js/http.js";
import modal from "@/assets/js/modal.js";

const state = () => ({
    filter: {
        keyword: null,
        requested: false,
        is_show_all: false,
        id_salesman: 20,
        month: 1,
        year: 2022,
        start_date: '2022-04-01',
        end_date: '2022-04-20'
    },
    response: {
        data: [],
        meta: [],
        filter: {
            perusahaans: [],
            depos: [],
            salesmans: [],
        },
    },
    modal: {
        filter: {
            backdrop: false,
            modal: false,
            data: {},
        }
    },
})

const mutations = {
}

const actions = {
    triggerModal({ state }, payload) {
        return modal.trigger(state, payload)
    },
    getInsentifSalesman({ state }, payload = null) {
        return http.get('insentif_salesman', state, payload)
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
